<template>
  <div class="lots-list tab-table p-2">
    <LotsTable :hide-actions="hideActions" :exclude-columns="excludeColumns"
               :exclude-search-fields="excludeSearchFields"/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import LotsTable from "../../../lots/LotsTable";
  import {
    ACTION_ARCHIVE_LOT,
    ACTION_BATCH_LOT_UP, ACTION_BATCH_UPDATE_HIDE_LOT, ACTION_BATCH_UPDATE_SESSION,
    ACTION_DELETE_LOT,
    ACTION_GENERATE_LOT_PRINTOUTS,
    ACTION_LOT_UP, ACTION_LOT_UP_USING_EXCEL,
    ACTION_LOT_UP_USING_QR,
    ACTION_PUBLISH_LOT,
    ACTION_REASSIGN_SALE,
    ACTION_RESERVE_ITEMS,
    ACTION_REVERT_TO_COMPLETED_LOT,
    ACTION_SYNC_LOTS
  } from "../../../constants";

  const {mapState} = createNamespacedHelpers('inventory');
  const {mapActions: lotsMapActions} = createNamespacedHelpers('lots');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "LotsList",
    components: {LotsTable},
    data() {
      return {
        excludeSearchFields: [
          'start_date', 'end_date',
          'receipt_no', 'item_no',
          'title', 'recommended_by_user_uuid',
          'customer_uuid', 'account_manager_uuid', 'bidder_uuid'
        ],
        hideActions: [
          ACTION_DELETE_LOT,
          ACTION_PUBLISH_LOT,
          ACTION_SYNC_LOTS,
          ACTION_ARCHIVE_LOT,
          ACTION_REVERT_TO_COMPLETED_LOT,
          ACTION_LOT_UP,
          ACTION_LOT_UP_USING_QR,
          ACTION_BATCH_LOT_UP,
          ACTION_RESERVE_ITEMS,
          ACTION_GENERATE_LOT_PRINTOUTS,
          ACTION_REASSIGN_SALE,
          ACTION_LOT_UP_USING_EXCEL,
          ACTION_BATCH_UPDATE_SESSION,
          ACTION_BATCH_UPDATE_HIDE_LOT,
        ],
      }
    },
    computed: {
      ...mapState({
        inventory: state => state.view.currentInventory
      }),
      ...globalMapState({
        enableContinuousAuction: state => state.enableContinuousAuction,
      }),
      excludeColumns() {
        let arr = [
          'image',
          'title',
          // 'item_no',
          'customer',
          'account_managers',
          'recommended_by_user',
          'actions',
        ]

        if (this.enableContinuousAuction) {
          arr.push('sale_no')
        }

        return arr
      }
    },
    methods: {
      ...lotsMapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'inventory',
        extraExpands: "auction.currency,lot.financial_item.invoice",
        extraFilters: {inventory_uuid: this.inventory.uuid},
      })
    }
  }
</script>

<style lang="scss" scoped>
</style>
